import useGetTicketsTableConfig from './useGetTicketsTableConfig'
export default useGetTicketsTableConfig
